'use strict';

module.exports = [
  '$scope',
  '$state',
  'Cropper',
  '$http',
  'toastService',
  'translateFilter',
  '$uibModal',
  'base64DownloadFactory',
  'fileExtensionFilter',
  'fileNameFilter',
  function (
    $scope,
    $state,
    Cropper,
    $http,
    toastService,
    translateFilter,
    $uibModal,
    base64DownloadFactory,
    fileExtensionFilter,
    fileNameFilter
  ) {
    $scope.stageImages = [];
    $scope.publishedImages = [];

    $scope.getImages = function (status) {
      var mainConfig = global.ngDroAstralSituationRecordMainConfig;
      var baseEndPointUrl = mainConfig.ApiUrl;
      var url = baseEndPointUrl + 'public-site-home-image';

      $http({
        method: 'GET',
        url: url,
        params: {
          status: status,
        },
        withCredentials: true,
      })
        .then(function successCallback(response) {
          if (status == 'STAGE') {
            $scope.stageImages = response.data;
          } else if (status == 'PUBLISHED') {
            $scope.publishedImages = response.data;
          }
        })
        .catch(function errorCallback(response) {
          console.log(response);

          var statusLabel = '';

          switch (status) {
            case 'STAGE':
              statusLabel = ' in stage';
              break;

            case 'PUBLISHED':
              statusLabel = ' pubblicate';
              break;

            default:
              break;
          }

          toastService.createErrorToast(
            'Errore durante il caricamento delle immagini' + statusLabel
          );
        });
    };

    $scope.deleteStageImage = function (id) {
      var mainConfig = global.ngDroAstralSituationRecordMainConfig;
      var baseEndPointUrl = mainConfig.ApiUrl;
      var url = baseEndPointUrl + 'public-site-home-image';

      var dialogInst = $uibModal.open({
        template: require('../modal/modalQuest.html'),
        controller: 'modalQuestCtrl',
        size: 'md',
        resolve: {
          params: function () {
            return {
              headerMessage: translateFilter('AstralSituationRecord.attention'),
              bodyMessage: 'Sei sicuro di voler eliminare?',
              showCancelButton: true,
              showYesButton: true,
              cancelButtonText: translateFilter('AstralSituationRecord.cancel'),
              yesButtonText: translateFilter('AstralSituationRecord.yes'),
            };
          },
        },
      });

      dialogInst.result.then(
        function () {
          $http({
            method: 'DELETE',
            url: url + '/' + id,
            withCredentials: true,
          })
            .then(function successCallback(response) {
              toastService.createSuccessToast('Immagine eliminata con successo');
              $scope.getImages('STAGE');
            })
            .catch(function errorCallback(response) {
              console.log(response);
              toastService.createErrorToast("Errore durante l'eliminazione dell'immagine");
            });
        },
        function () {}
      );
    };

    $scope.deletePublishedImage = function (id) {
      var dialogInst = $uibModal.open({
        template: require('../modal/modalQuest.html'),
        controller: 'modalQuestCtrl',
        size: 'md',
        resolve: {
          params: function () {
            return {
              headerMessage: translateFilter('AstralSituationRecord.attention'),
              bodyMessage: 'Sei sicuro di voler eliminare?',
              showCancelButton: true,
              showYesButton: true,
              cancelButtonText: translateFilter('AstralSituationRecord.cancel'),
              yesButtonText: translateFilter('AstralSituationRecord.yes'),
            };
          },
        },
      });

      dialogInst.result.then(
        function () {
          var mainConfig = global.ngDroAstralSituationRecordMainConfig;
          var baseEndPointUrl = mainConfig.ApiUrl;
          var url = baseEndPointUrl + 'public-site-home-image';

          $http({
            method: 'DELETE',
            url: url + '/' + id,
            withCredentials: true,
          })
            .then(function successCallback(response) {
              toastService.createSuccessToast('Immagine eliminata con successo');
              $scope.getImages('PUBLISHED');
            })
            .catch(function errorCallback(response) {
              console.log(response);
              toastService.createErrorToast("Errore durante l'eliminazione dell'immagine");
            });
        },
        function () {}
      );
    };

    $scope.publishStageImage = function (id) {
      var dialogInst = $uibModal.open({
        template: require('../modal/modalQuest.html'),
        controller: 'modalQuestCtrl',
        size: 'md',
        resolve: {
          params: function () {
            return {
              headerMessage: translateFilter('AstralSituationRecord.attention'),
              bodyMessage: 'Sei sicuro di voler pubblicare?',
              showCancelButton: true,
              showYesButton: true,
              cancelButtonText: translateFilter('AstralSituationRecord.cancel'),
              yesButtonText: translateFilter('AstralSituationRecord.yes'),
            };
          },
        },
      });

      dialogInst.result.then(
        function () {
          var mainConfig = global.ngDroAstralSituationRecordMainConfig;
          var baseEndPointUrl = mainConfig.ApiUrl;
          var url = baseEndPointUrl + 'public-site-home-image';

          $http({
            method: 'GET',
            url: url + '/publish/' + id,
            withCredentials: true,
          })
            .then(function successCallback(response) {
              $scope.stageImages = $scope.stageImages.filter(function (image) {
                return image.id != id;
              });

              toastService.createSuccessToast('Immagine pubblicata con successo');

              $scope.getImages('STAGE');
            })
            .catch(function errorCallback(response) {
              console.log(response);
              toastService.createErrorToast("Errore durante la pubblicazione dell'immagine");
            });
        },
        function () {}
      );
    };

    $scope.unpublishPublishedImage = function (id) {
      var dialogInst = $uibModal.open({
        template: require('../modal/modalQuest.html'),
        controller: 'modalQuestCtrl',
        size: 'md',
        resolve: {
          params: function () {
            return {
              headerMessage: translateFilter('AstralSituationRecord.attention'),
              bodyMessage: 'Sei sicuro di voler nascondere?',
              showCancelButton: true,
              showYesButton: true,
              cancelButtonText: translateFilter('AstralSituationRecord.cancel'),
              yesButtonText: translateFilter('AstralSituationRecord.yes'),
            };
          },
        },
      });

      dialogInst.result.then(
        function () {
          var mainConfig = global.ngDroAstralSituationRecordMainConfig;
          var baseEndPointUrl = mainConfig.ApiUrl;
          var url = baseEndPointUrl + 'public-site-home-image';

          $http({
            method: 'GET',
            url: url + '/unpublish/' + id,
            withCredentials: true,
          })
            .then(function successCallback(response) {
              $scope.stageImages = $scope.stageImages.filter(function (image) {
                return image.id != id;
              });

              toastService.createSuccessToast('Immagine pubblicata con successo');

              $scope.getImages('PUBLISHED');
            })
            .catch(function errorCallback(response) {
              console.log(response);
              toastService.createErrorToast("Errore durante la pubblicazione dell'immagine");
            });
        },
        function () {}
      );
    };

    $scope.updateOrder = function () {
      var mainConfig = global.ngDroAstralSituationRecordMainConfig;
      var baseEndPointUrl = mainConfig.ApiUrl;
      var url = baseEndPointUrl + 'public-site-home-image';

      $http({
        method: 'POST',
        url: url + '/update-order',
        data: $scope.publishedImages,
        withCredentials: true,
      })
        .then(function successCallback(response) {
          $scope.getImages('PUBLISHED');
          toastService.createSuccessToast('Ordine aggiornato con successo');
        })
        .catch(function errorCallback(response) {
          console.log(response);
          toastService.createErrorToast("Errore durante l'aggiornamento dell'ordine");
        });
    };

    $scope.getImages('STAGE');
    $scope.getImages('PUBLISHED');

    $scope.dataX;
    $scope.dataY;
    $scope.dataHeight;
    $scope.dataWidth;
    $scope.dataRotate;
    $scope.dataScaleX;
    $scope.dataScaleY;
    $scope.uploadedImageType;
    $scope.uploadedImageName;
    $scope.uploadedImageURL;
    $scope.cropper;

    $scope.ready = false;

    var inputImage = document.getElementById('inputImage');
    var image = document.getElementById('image');
    var options = {
      aspectRatio: 1187 / 415,
      preview: '.img-preview',
      ready: function (e) {
        $scope.ready = true;
        $scope.$apply();
      },
      cropstart: function (e) {},
      cropmove: function (e) {},
      cropend: function (e) {},
      crop: function (e) {
        var data = e.detail;

        $scope.dataX = Math.round(data.x);
        $scope.dataY = Math.round(data.y);
        $scope.dataHeight = Math.round(data.height);
        $scope.dataWidth = Math.round(data.width);
        $scope.dataRotate = typeof data.rotate !== 'undefined' ? data.rotate : '';
        $scope.dataScaleX = typeof data.scaleX !== 'undefined' ? data.scaleX : '';
        $scope.dataScaleY = typeof data.scaleY !== 'undefined' ? data.scaleY : '';
      },
      zoom: function (e) {},
    };

    inputImage.onchange = function () {
      var files = this.files;
      var file;

      if (files && files.length) {
        file = files[0];

        if (/^image\/\w+/.test(file.type)) {
          $scope.uploadedImageType = file.type;
          $scope.uploadedImageName = file.name;

          image.src = $scope.uploadedImageURL = URL.createObjectURL(file);

          if ($scope.cropper) {
            $scope.cropper.destroy();
          }

          $scope.cropper = new Cropper(image, options);
        } else {
          window.alert('Please choose an image file.');
        }
      }
    };

    $scope.upload = function () {
      $scope.cropper.getCroppedCanvas().toBlob(
        function (blob) {
          var formData = new FormData();

          formData.append('file', blob, $scope.uploadedImageName);
          formData.append(
            'request',
            JSON.stringify({
              clazz: 'com.dromedian.jdro.datex2.domain.PublicSiteHomeImage',
              id: null,
            })
          );

          var mainConfig = global.ngDroAstralSituationRecordMainConfig;
          var baseEndPointUrl = mainConfig.ApiUrl;
          var url = baseEndPointUrl + 'public-site-home-image';

          $http
            .post(url, formData, {
              withCredentials: true,
              headers: {
                'Content-Type': undefined,
              },
            })
            .then(function (response) {
              toastService.createSuccessToast('Immagine caricata con successo');

              $scope.cropper.destroy();
              $scope.cropper = null;
              $scope.uploadedImageType = null;
              $scope.uploadedImageName = null;
              $scope.uploadedImageURL = null;
              $scope.dataX = null;
              $scope.dataY = null;
              $scope.dataHeight = null;
              $scope.dataWidth = null;
              $scope.dataRotate = null;
              $scope.dataScaleX = null;
              $scope.dataScaleY = null;
              $scope.ready = false;
              var image = document.getElementById('image');
              image.src = '';
              document.getElementById('inputImage').value = '';

              $scope.getImages('STAGE');
            })
            .catch(function (error) {
              console.log(error);
              toastService.createErrorToast("Errore durante il caricamento dell'immagine");
            });
        },
        $scope.uploadedImageType,
        1
      );
    };

    $scope.cancelUpload = function () {
      $scope.cropper.destroy();
      $scope.cropper = null;
      $scope.uploadedImageType = null;
      $scope.uploadedImageName = null;
      $scope.uploadedImageURL = null;
      $scope.dataX = null;
      $scope.dataY = null;
      $scope.dataHeight = null;
      $scope.dataWidth = null;
      $scope.dataRotate = null;
      $scope.dataScaleX = null;
      $scope.dataScaleY = null;
      $scope.ready = false;
      var image = document.getElementById('image');
      image.src = '';
      document.getElementById('inputImage').value = '';
    };

    $scope.downloadImage = function (id, filename) {
      var mainConfig = global.ngDroAstralSituationRecordMainConfig;
      var baseEndPointUrl = mainConfig.ApiUrl;
      var url = baseEndPointUrl + 'public-site-home-image';

      $http({
        method: 'GET',
        url: url + '/' + id + '/attachment-download',
        withCredentials: true,
        responseType: 'arraybuffer',
      })
        .then(function successCallback(response) {
          // eslint-disable-next-line no-undef
          var arrayBufferView = new Uint8Array(response.data);
          var blob = new Blob([arrayBufferView], { type: response.headers('Content-Type') });
          var urlCreator = window.URL || window.webkitURL;
          var url = urlCreator.createObjectURL(blob);

          var a = document.createElement('a');
          document.body.appendChild(a);
          a.style = 'display: none';
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(function errorCallback(response) {
          console.log(response);
          toastService.createErrorToast("Errore durante il download dell'immagine");
        });
    };

    /* ---------------------------------- Tabs ---------------------------------- */
    $scope.openTab = function (evt, tabName) {
      var i, tabcontent, tablinks;

      tabcontent = document.getElementsByClassName('upload-tabs--tabcontent');
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = 'none';
      }

      tablinks = document.getElementsByClassName('upload-tabs--tablinks');
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(' active', '');
      }

      document.getElementById(tabName).style.display = 'block';
      evt.currentTarget.className += ' active';

      $scope.getImages(tabName);

      var dragoverListener;
      var dragenterListener;
      var dragleaveListener;
      var dropListener;

      if (tabName === 'STAGE') {
        var supportsFileSystemAccessAPI = 'getAsFileSystemHandle' in DataTransferItem.prototype;
        var supportsWebkitGetAsEntry = 'webkitGetAsEntry' in DataTransferItem.prototype;

        var elem = document.querySelector('#drop_zone');

        dragoverListener = elem.addEventListener('dragover', function (e) {
          e.preventDefault();
        });

        dragenterListener = elem.addEventListener('dragenter', function (e) {
          elem.style.border = 'dashed 3px #000';
        });

        dragleaveListener = elem.addEventListener('dragleave', function (e) {
          elem.style.border = '3px dashed #d1d5db';
        });

        dropListener = elem.addEventListener('drop', function (e) {
          e.preventDefault();

          elem.style.border = '3px dashed #d1d5db';

          var fileHandlesPromises = Array.from(e.dataTransfer.items)
            .slice(0, 1)
            .filter(function (item) {
              return item.kind === 'file' && item.type.includes('image');
            })
            .map(function (item) {
              return supportsFileSystemAccessAPI
                ? item.getAsFileSystemHandle()
                : supportsWebkitGetAsEntry
                ? item.webkitGetAsEntry()
                : item.getAsFile();
            });

          function handleFile(file) {
            if (file.kind === 'directory' || file.isDirectory) {
              toastService.createErrorToast('Non è possibile caricare una cartella');
              return;
            }

            if (supportsFileSystemAccessAPI) {
              file.getFile().then(function (file) {
                if (!/^image\/\w+/.test(file.type)) {
                  toastService.createErrorToast('Il file caricato non è un immagine');
                  return;
                }

                $scope.uploadedImageType = file.type;
                $scope.uploadedImageName = file.name;

                image.src = $scope.uploadedImageURL = URL.createObjectURL(file);

                if ($scope.cropper) {
                  $scope.cropper.destroy();
                }

                $scope.cropper = new Cropper(image, options);
              });
            }

            if (!supportsFileSystemAccessAPI && supportsWebkitGetAsEntry) {
              file.file(function (file) {
                if (!/^image\/\w+/.test(file.type)) {
                  toastService.createErrorToast('Il file caricato non è un immagine');
                  return;
                }

                $scope.uploadedImageType = file.type;
                $scope.uploadedImageName = file.name;

                image.src = $scope.uploadedImageURL = URL.createObjectURL(file);

                if ($scope.cropper) {
                  $scope.cropper.destroy();
                }

                $scope.cropper = new Cropper(image, options);
              });
            }

            if (!supportsFileSystemAccessAPI && !supportsWebkitGetAsEntry) {
              if (!/^image\/\w+/.test(file.type)) {
                toastService.createErrorToast('Il file caricato non è un immagine');
                return;
              }

              $scope.uploadedImageType = file.type;
              $scope.uploadedImageName = file.name;

              image.src = $scope.uploadedImageURL = URL.createObjectURL(file);

              if ($scope.cropper) {
                $scope.cropper.destroy();
              }

              $scope.cropper = new Cropper(image, options);
            }
          }

          fileHandlesPromises.forEach(function (promiseOrValue) {
            if (promiseOrValue.then === undefined) {
              handleFile(promiseOrValue);
            } else {
              promiseOrValue.then(function (promise) {
                handleFile(promise);
              });
            }
          });
        });
      } else {
        elem.removeEventListener('dragover', dragoverListener);
        elem.removeEventListener('dragenter', dragenterListener);
        elem.removeEventListener('dragleave', dragleaveListener);
        elem.removeEventListener('drop', dropListener);
      }
    };

    /* ------------------------------ Drag and Drop ----------------------------- */
    var dragImageId = null;

    $scope.handleDragStart = function (event, index) {
      event.originalEvent.srcElement.style.opacity = '0.4';

      dragImageId = index;

      event.originalEvent.dataTransfer.effectAllowed = 'move';
      event.originalEvent.dataTransfer.setData('text/html', event.originalEvent.srcElement);
    };

    $scope.handleDragOver = function (event, index) {
      if (event.originalEvent.preventDefault) {
        event.originalEvent.preventDefault();
      }

      event.originalEvent.dataTransfer.dropEffect = 'move';

      return false;
    };

    $scope.handleDragEnter = function (event, index) {
      var elementWithDraggableAttribute =
        event.originalEvent.toElement.closest('[draggable="true"]');
      elementWithDraggableAttribute.classList.add('over');
    };

    $scope.handleDragLeave = function (event, index) {
      var elementWithDraggableAttribute =
        event.originalEvent.toElement.closest('[draggable="true"]');
      if (!elementWithDraggableAttribute.contains(event.originalEvent.relatedTarget)) {
        elementWithDraggableAttribute.classList.remove('over');
      }
    };

    $scope.handleDrop = function (event, index) {
      if (event.originalEvent.stopPropagation) {
        event.originalEvent.stopPropagation();
      }

      if (dragImageId !== index) {
        var temp = $scope.publishedImages[index];
        $scope.publishedImages[index] = $scope.publishedImages[dragImageId];
        $scope.publishedImages[dragImageId] = temp;
      }

      return false;
    };

    $scope.handleDragEnd = function (event, index) {
      event.originalEvent.srcElement.style.opacity = '1';

      $scope.publishedImages = $scope.publishedImages.map(function (image, index) {
        image.order = index + 1;
        return image;
      });

      var items = document.querySelectorAll(
        '.public-carousel--dnd--container .public-carousel--dnd--box'
      );
      items.forEach(function (item) {
        item.classList.remove('over');
      });
    };
  },
];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/publicCarousel/publicCarouselCtrl.js
// module id = 251
// module chunks = 0